module.exports = __webpack_public_path__ + "static/media/surface1.478fec5d.svg";